<div class="content dark">
	<div class="form-group row">
		<label class="col-md-6">For safety, all operations require you to confirm OBCU serial number here:</label>
		<div class="col-md-6">
			<input [(ngModel)]="confirmOBCU" type="text" class="form-control">
		</div>
	</div>
	<hr class="my-4">
	<h5>Reset the auth key</h5>
	<p class="message-info">This will generate a new, random auth key for the asset. Note that if the OBCU is currently connecting successfully, this will break it until the
		configuration is updated with the new auth key</p>
	<div class="form-group row">
		<div class="col-md-8 offset-md-4">
			<app-action-button [action]="ResetAuth" [context]="this" processing="Resetting..." complete="Asset auth reset" btnClass="btn-danger"
				confirm="Are you sure? You will need to change the OBCU config">Reset auth key
			</app-action-button>
		</div>
	</div>
	<div *ngIf="resetAssetAuth">
		<p class="message-good">The asset has been reset, with the auth key below. Copy this key and save
			it to the OBCU config. You will not be able to come back and look it up again.</p>
		<div class="form-group row">
			<label class="col-md-4">Asset auth key</label>
			<div class="col-md-8">{{resetAssetAuth}}</div>
		</div>
	</div>
	<hr class="my-4">
	<h5>Delete an acquisition</h5>
	<p class="message-info">This will PERMANENTLY delete this acquisition from the database. This includes all HIs, CIs, RAWs, etc that are attached to the acquisition. This is
		not undoable. You must confirm by typing in the OBCU serial number above. You will need to recalculate states ("Recalculate data" tab) afterwards.</p>
	<div *ngIf="!asset.is_fixed" class="form-group row">
		<label class="col-md-4">Operation:</label>
		<div class="col-md-8">
			<select class="form-control form-control-sm op-list" [(ngModel)]="operationForAcq" (ngModelChange)="ListAcquisitions()"
				title="Showing {{ assetOps && assetOps.length >= 800 ? 'latest 800' : 'all' }} operations">
				<option *ngFor="let operation of assetOps" [ngValue]="operation"
					[ngClass]="{ 'unacked-ex' : operation.exceedance_count > 0 && !operation.exceedance_ack_by, 'acked-ex': operation.exceedance_count > 0 && operation.exceedance_ack_by, 'no-ex': operation.exceedance_count === 0 }">
					{{operation.start_time | datetime : "offset" : asset.time_offset_hours}}{{operation.rotor_turn_time | runtime : " Rotor:"}}{{operation.flight_time | runtime :
					" Flight: "}}{{operation.exceedance_count > 0 ? " Ex: " + operation.exceedance_count : ""}}{{operation.exceedance_count && operation.exceedance_ack_by ? " (ack)" : ""}}
				</option>
			</select>
		</div>
	</div>
	<div *ngIf="asset.is_fixed" class="form-group row">
		<label class="col-md-4">Date (UTC):</label>
		<div class="col-md-8">
			<app-day-picker [(ngModel)]="dateForAcq" (ngModelChange)="ListAcquisitions()"></app-day-picker>
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Component:</label>
		<div class="col-md-8">
			<select class="form-control form-control-sm op-list" [(ngModel)]="componentForAcq" (ngModelChange)="ListAcquisitions()">
				<option *ngFor="let component of componentList" [ngValue]="component">
					{{component.name}} ({{component.id}})
				</option>
			</select>
		</div>
	</div>
	<div *ngIf="acquisitionList" class="form-group row">
		<label class="col-md-4">Acquisition:</label>
		<div class="col-md-8">
			<select class="form-control form-control-sm op-list" [(ngModel)]="acquisitionToDelete">
				<option *ngFor="let acquisition of acquisitionList" [ngValue]="acquisition">
					{{acquisition.timestamp | datetime : "offset" : asset.time_offset_hours}} Comp: {{acquisition.component_key}}
				</option>
			</select>
		</div>
	</div>
	<div class="form-group row my-3">
		<div class="col-md-6 offset-md-3">
			<app-action-button [action]="DeleteAcquisition" [context]="this" [disabled]="!acquisitionToDelete" processing="Deleting..." complete="Acquisition deleted" btnClass="btn-danger btn-block">Delete this acquisition</app-action-button>
		</div>
	</div>
	<hr class="my-4">
	<h5>Delete an operation</h5>
	<p class="message-info">This will PERMANENTLY delete this operation from the database. This includes all HIs, CIs, ACSTATEs, RAWs, etc that are attached to the operation. This is
		not undoable. You must confirm by typing in the OBCU serial number above. You will need to recalculate states ("Recalculate data" tab) afterwards.</p>
	<div class="form-group row">
		<div class="col-md-12">
			<select class="form-control form-control-sm op-list" [(ngModel)]="operationToDelete"
				title="Showing {{ assetOps && assetOps.length >= 800 ? 'latest 800' : 'all' }} operations">
				<option *ngFor="let operation of assetOps" [ngValue]="operation"
					[ngClass]="{ 'unacked-ex' : operation.exceedance_count > 0 && !operation.exceedance_ack_by, 'acked-ex': operation.exceedance_count > 0 && operation.exceedance_ack_by, 'no-ex': operation.exceedance_count === 0 }">
					{{operation.start_time | datetime : "offset" : asset.time_offset_hours}}{{operation.rotor_turn_time | runtime : " Rotor:"}}{{operation.flight_time | runtime :
					" Flight: "}}{{operation.exceedance_count > 0 ? " Ex: " + operation.exceedance_count : ""}}{{operation.exceedance_count && operation.exceedance_ack_by ? " (ack)" : ""}}
				</option>
			</select>
		</div>
	</div>
	<div class="form-group row my-3">
		<div class="col-md-6 offset-md-3">
			<app-action-button [action]="DeleteOperation" [context]="this" [disabled]="!operationToDelete" processing="Deleting..." complete="Operation deleted" btnClass="btn-danger btn-block">Delete this ENTIRE
				operation</app-action-button>
		</div>
	</div>
	<hr class="my-4">
	<h5>Delete all data</h5>
	<p class="message-info">This is PERMANENT and will delete ALL DATA associated with the selected asset. This includes all operations, acquisitions, and raw data. This is not
		undoable. You must confirm by typing in the OBCU serial number above.</p>
	<div class="form-group row">
		<div class="col-md-8 offset-md-4">
			<app-action-button [action]="WipeAsset" [context]="this" processing="Wiping..." complete="Asset wiped" btnClass="btn-danger"
				confirm="Are you sure? This will permanently delete all asset data">Wipe ALL DATA for this asset</app-action-button>
		</div>
	</div>
	<hr class="my-4">
	<h5>Delete this asset entirely</h5>
	<p class="message-info">This is PERMANENT and will delete ALL DATA associated with the selected asset, as well as the asset record itself. This includes the OBCU login
		information, as well as all operations, acquisitions, and raw data. This is not undoable. You must confirm by typing in the OBCU serial number above.</p>
	<div class="form-group row">
		<div class="col-md-8 offset-md-4">
			<app-action-button [action]="DeleteAsset" [context]="this" processing="Deleting..." complete="Asset deleted" btnClass="btn-danger"
				confirm="Are you sure? This will permanently delete the asset and all data">Delete this asset and ALL DATA</app-action-button>
		</div>
	</div>
</div>